import '@alwatr/polyfill-has-own';
import React from 'react';
import { createRoot } from 'react-dom/client';
import Arts, { store } from 'arts';
import Footer from 'arts/components/footer';
import About from 'arts/components/about';
import HpPromoV2 from 'arts/components/hp_promo/hp_promo_v2';
import TopArtists from 'arts/components/top_artists';
import { Router, useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import CmsWorksWidget from 'arts/components/cms_works_widget';
import QuickShop from 'arts/components/QuickShopModal/quick_shop';
import { initSentry } from 'shared/sentry';
import { setupAnalytics } from 'arts/config/analytics';

document.addEventListener('DOMContentLoaded', () => {
  initSentry();

  setupAnalytics();

  const hproot = document.getElementById('b-topwide');
  if (hproot) {
    const root = createRoot(hproot);
    root.render(<HpPromoV2 config={ JSON.parse(hproot.dataset.config) } showArrows={ false } />);
  }

  const rootElement = document.getElementById('client-application-root');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<Arts store={ store } />);
  }

  const footerEl = document.getElementById('footer');
  if (footerEl) {
    const root = createRoot(footerEl);
    root.render(<Footer store={ store } />);
  }

  const aboutB = document.getElementById('about-b');
  if (aboutB && !window.skipAbout) {
    const root = createRoot(aboutB);
    root.render(<About store={ store } />);
  }

  const topArtist = document.getElementById('top-artists');
  if (topArtist) {
    const root = createRoot(topArtist);
    root.render(<TopArtists />);
  }

  const cmsWidgets = document.querySelectorAll('[data-cms-works-widget]');
  if (cmsWidgets.length > 0) {
    const cmsHistory = createBrowserHistory();
    const cmsOriginPath = window.location.pathname;
    const originalPush = cmsHistory.push.bind(cmsHistory);

    cmsHistory.push = (path, state) => {
      const pathname = typeof path === 'string' ? path.split('?')[0] : path.pathname;
      if (pathname !== cmsOriginPath) {
        const url = typeof path === 'string' ? path : path.pathname + (path.search || '');
        window.location.href = url;
        return;
      }
      originalPush(path, state);
    };

    cmsWidgets.forEach((el) => {
      const slug = el.dataset.cmsWorksWidget;
      if (slug) {
        const root = createRoot(el);
        root.render(
          <Provider store={ store }>
            <Router history={ cmsHistory }>
              <CmsWorksWidget slug={ slug } />
            </Router>
          </Provider>
        );
      }
    });

    const LocationAwareQuickShop = () => {
      useLocation();
      return <QuickShop />;
    };

    const qsEl = document.querySelector('[data-cms-quick-shop]');
    if (qsEl) {
      const root = createRoot(qsEl);
      root.render(
        <Provider store={ store }>
          <Router history={ cmsHistory }>
            <LocationAwareQuickShop />
          </Router>
        </Provider>
      );
    }
  }
});
